"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reachify = void 0;
var reachify = function (reduxHistory) {
    var transitioning = false;
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    var resolveTransition = function () { };
    return {
        // eslint-disable-next-line no-underscore-dangle
        _onTransitionComplete: function () {
            transitioning = false;
            resolveTransition();
        },
        listen: function (listener) {
            if (reduxHistory.listenObject) {
                // @ts-ignore
                return reduxHistory.listen(listener);
            }
            // @ts-ignore
            return reduxHistory.listen(function (location, action) { return listener({ location: location, action: action }); });
        },
        // @ts-ignore
        navigate: function (to, _a) {
            var _b = _a === void 0 ? {} : _a, state = _b.state, _c = _b.replace, replace = _c === void 0 ? false : _c;
            if (transitioning || replace) {
                reduxHistory.replace(to, state);
            }
            else {
                reduxHistory.push(to, state);
            }
            transitioning = true;
            // eslint-disable-next-line no-return-assign
            // @ts-ignore
            return new Promise(function (res) { return (resolveTransition = res); });
        },
        // @ts-ignore
        get location() {
            return reduxHistory.location;
        },
        get transitioning() {
            return transitioning;
        },
    };
};
exports.reachify = reachify;
//# sourceMappingURL=reachify.js.map